import { ChangeDetectionStrategy, Component, HostBinding, Input } from '@angular/core';
import { ArrowDirection, CUSTOM_ICON_TYPE } from '@shared/models';
import { IconModule } from '@spartacus/storefront';

@Component({
  selector: 'button[sd-slider-arrow]',
  templateUrl: './slider-arrow.component.html',
  styleUrls: ['./slider-arrow.component.scss'],
  imports: [IconModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SdvorSliderArrowComponent {
  /**
   * Направление стрелки
   */
  @Input() direction: ArrowDirection = ArrowDirection.Left;

  iconType = CUSTOM_ICON_TYPE;

  @HostBinding('class')
  get classNames(): string[] {
    return [this.direction && `direction-${this.direction}`].filter(Boolean);
  }
}
